import { useEffect } from 'react';
import { ResultsDashboard } from '../components/ResultsDashboard.js';
import { ScoreResult } from '../types/index.js';
import { api } from '../api/client.js';

interface Props {
  results: ScoreResult;
  sessionId: string;
  playerName: string;
  playerEmail: string;
  onPlayAgain: () => void;
  onViewLeaderboard: () => void;
}

export function ResultsPage({ results, sessionId, playerName, playerEmail, onPlayAgain, onViewLeaderboard }: Props) {
  useEffect(() => {
    api.saveScore({
      sessionId,
      playerName,
      playerEmail,
      score: results.userScore,
      fraudPrevented: results.userFraudPrevented,
    }).catch(() => {
      // Non-critical — leaderboard save failure shouldn't break the results view
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // fire once on mount

  return (
    <ResultsDashboard
      results={results}
      onPlayAgain={onPlayAgain}
      onViewLeaderboard={onViewLeaderboard}
    />
  );
}
